<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    max-width="90vw"
  >
    <v-card>
      <v-card-title class="d-flex align-start justify-space-between">
        <p>{{ title }}</p>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="better-scrollbar">
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12" class="pa-2">
              <v-text-field
                v-model="object.name"
                :label="$t('crashes.name')"
                :disabled="!isEditting"
                outlined
                dense
                rounded
                :error="hasErrors('name')"
                :error-messages="getErrors('name')"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="d-flex justify-space-between">
        <v-btn
          v-if="isEditting"
          @click="discardItem"
          small
          :ripple="false"
          outlined
          class="text-capitalize"
          dark
          color="primary"
        >
          {{ $t('actions.discard') }}
        </v-btn>
        <v-btn
          v-if="isEditting"
          @click="saveItem(object.id)"
          small
          :ripple="false"
          depressed
          class="text-capitalize"
          color="primary"
        >
          {{ $t('actions.save') }}
        </v-btn>
        <v-btn
          v-if="!isEditting"
          @click="isEditting = true"
          small
          :ripple="false"
          depressed
          class="text-capitalize"
          color="orange darken-1 white--text"
        >
          {{ $t('actions.edit') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { orm } from '@/mixins'
import addMutation from '@/graphql/mutations/crashes/add.gql'
import editMutation from '@/graphql/mutations/crashes/edit.gql'

export default {
  model: {
    prop: 'data',
    event: 'set-object'
  },

  mixins: [orm],

  props: {
    showDialog: { type: Boolean, default: () => false },
    data: { type: Object, default: () => {} },
    isEditting: {
      type: Boolean,
      default: () => false
    }
  },

  data () {
    return {
      objectMap: {
        location: ''
      },
      show: false,
      errors: {}
    }
  },

  computed: {
    ...mapState(['isDark', 'users', 'crashes']),
    object: {
      get () {
        return this.data
      },

      set (value) {
        this.$emit('toggle-object', value)
      }
    },

    dialog: {
      get () {
        return this.showDialog
      },

      set (value) {
        this.$emit('toggle-dialog', value)
      }
    },

    title () {
      return this.object.id === undefined ? this.$i18n.t('crashes.new') : this.$i18n.t('crashes.edit')
    }
  },

  watch: {},

  created () {
    console.log('hola')
  },

  methods: {
    async saveItem (id) {
      this.isLoading = true
      const data = {
        id: id,
        name: this.object.name
      }
      if (id) {
        await this.edit(data)
      } else {
        await this.add(data)
      }
    },

    evaluateResponse ({ status, errors, result, action }) {
      this.isLoading = false
      console.log(status, errors)
      switch (status) {
        case 'OK':
          this.discardItem()
          this.resetErrors()
          this.$store.commit('toggleSnackbar', {
            color: 'green darken-2',
            message: this.$t('helpers.save.success')
          })
          if (action === 'add') {
            this.$store.dispatch('crashes/getList', true)
          }
          break
        case 'UNPROCESSABLE':
          this.errors = this.parseErrors(errors)
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.invalidFields')
          })
          break
        case 'BADREQUEST':
          this.errors = this.parseErrors(errors)
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.invalidFields')
          })
          break
        case 'LIMITREACHED':
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.limit_reached')
          })
          break
      }
    },

    add (data) {
      const action = 'add'
      this.$apollo.mutate({
        mutation: addMutation,
        variables: {
          apiToken: this.users.entity.apiToken,
          data
        },
        fetchPolicy: 'no-cache'
      }).then(response => {
        const { status, errors, result } = response.data.addCrash
        this.evaluateResponse({ status, errors, result, action })
      }).catch(err => {
        console.log('[Devices Dialog] Error handled', err)
        this.$store.commit('toggleSnackbar', {
          color: 'red darken-2',
          message: this.$t('helpers.errors.disaster')
        })
      })
    },

    edit (data) {
      const action = 'edit'
      this.$apollo.mutate({
        mutation: editMutation,
        variables: {
          apiToken: this.users.entity.apiToken,
          data
        },
        fetchPolicy: 'no-cache'
      }).then(response => {
        const { status, errors, result } = response.data.editCrash
        this.evaluateResponse({ status, errors, result, action })
      }).catch(err => {
        console.log('[Devices Dialog] Error handled', err)
        this.$store.commit('toggleSnackbar', {
          color: 'red darken-2',
          message: this.$t('helpers.errors.disaster')
        })
      })
    },

    discardItem () {
      this.dialog = false
      this.object = Object.assign({}, this.$store.getters['crashes/defaultObject'])
      this.resetErrors()
    }
  }
}
</script>
